export type Mapper = {
  cookiesName: string;
  queryParamName: string;
  analyticType: string;
  analyticName: string;
  value?: string;
}

export const flowId = {
  cookiesName: 'flowId',
  queryParamName: 'f',
  analyticType: 'extraData',
  analyticName: 'FlowId'
};

export const homeUserId = {
  cookiesName: 'homeUserId',
  queryParamName: 'ap_hid',
  analyticType: 'identity',
  analyticName: 'HomeUserId'
};

export const messageId = {
  cookiesName: 'messageId',
  queryParamName: 'ap_mid',
  analyticType: 'identity',
  analyticName: 'MessageId'
};


// WEBPACK FOOTER //
// ./packages/web-app/src/queryParametersForAnalytics.ts